module.exports = __webpack_public_path__ + "static/media/close--light.a5343410.svg";